export default __webpack_public_path__ + "static/media/my_location_black_24dp.32e05c8d.svg";